import { FC, HTMLAttributes, useState, useRef, useEffect } from "react";
import { BaseImg } from "../../types";
import { Slide } from "./Slide";
import { Slider, SliderHandle } from "./Slider";
import { Control } from "./Control";
import { Controls } from "./Controls";
import { SafeImage } from "../SafeImage";
import { Icon } from "../Icon";

interface ImgSliderProps extends HTMLAttributes<HTMLElement> {
    imgs: BaseImg[]
    className?: string
}

export const ImgSlider: FC<ImgSliderProps> = ({imgs, className, ...rest}) => {

    const [current, setCurrent] = useState<number>(0)
    //this does not move the slider, just to calc if controls should be disabled
    const slider = useRef<SliderHandle>(null)

    return (
        <section className={`section slider-container img-slider w-100 p-r o-h r3 ${className ?? ''}`} {...rest}>
            <Slider ref={slider}>
            { imgs.map(({src, alt}, index) => 
                <Slide key={index}>
                    <SafeImage src={src} alt={alt} className="h-100 w-100"/>
                </Slide>
            )}
            </Slider>

            <Controls slider={slider} className="p-a w-100 h-100 df aic jcsb zi-3 controls">
                <Control 
                    goTo={"previous"} 
                    className=" button black p-5 df aic jcc control b-0"
                    disabled={current===0}
                    onClick={() => setCurrent(x => x - 1)}
                >
                    <Icon icon="arrow-rounded" style={{scale: '1.2'}}/>
                </Control>
                <Control 
                    goTo={"next"} 
                    className="rt-180 button black p-5 df aic jcc control b-0"
                    disabled={current+1 === slider.current?.getSlidesQty()}
                    onClick={() => setCurrent( x => x + 1)}
                >
                    <Icon icon="arrow-rounded" style={{scale: '1.2'}}/>
                </Control>
            </Controls>
        </section>
    )
}